// src/components/CardsHeader.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLeft } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowTrendUp,
  faHouse,
  faTableColumns,
  faDiagramProject,
} from "@fortawesome/free-solid-svg-icons";
import { FaFolderOpen, FaFlag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { images } from "../config/images";
import "./CardsHeader.css";

const PRIORIDADES = [
  { key: "alta",  label: "Alta Prioridade",  color: "#dc2626" },
  { key: "media", label: "Média Prioridade", color: "#d97706" },
  { key: "baixa", label: "Baixa Prioridade", color: "#16a34a" },
];

const CORES_TAG = ["#3b82f6", "#16a34a", "#d97706", "#dc2626", "#9333ea", "#0891b2", "#db2777", "#475569"];
const TAG_VAZIA = { nome: "", cor: CORES_TAG[0], negrito: false, italico: false };

export default function CardsHeader({
  entity,
  ehSetor = false,
  membros,
  donoContainerId,
  onToggleArquivadas,
  modoArquivadas,
  onToggleGraficos,
  modoGraficos,
  columnsNormais = [],
  onToggleProjetos,
  modoProjetos,
  filtroPrioridade,
  onSetFiltroPrioridade,
  filtroTag,
  onSetFiltroTag,
  pilhaSelecionada,
  onSelectPilha,
  onResetView,
  modoHome,
  onToggleHome,
  tags = [],
  onCreateTag,
  onUpdateTag,
  onDeleteTag,
}) {
  const navigate = useNavigate();

  const [formTag, setFormTag] = useState(null);
  const [editandoTagId, setEditandoTagId] = useState(null);

  const abrirNovaTag = () => { setEditandoTagId(null); setFormTag({ ...TAG_VAZIA }); };
  const abrirEditarTag = (t) => {
    setEditandoTagId(t.id);
    setFormTag({ nome: t.nome, cor: t.cor, negrito: !!t.negrito, italico: !!t.italico });
  };
  const fecharFormTag = () => { setFormTag(null); setEditandoTagId(null); };
  const salvarTag = async () => {
    const nome = formTag.nome.trim();
    if (!nome) return;
    const dados = { ...formTag, nome };
    if (editandoTagId) await onUpdateTag?.(editandoTagId, dados);
    else await onCreateTag?.(dados);
    fecharFormTag();
  };
  const handleDragStartTag = (e, tagId) => {
    e.dataTransfer.setData("tag", String(tagId));
    e.dataTransfer.effectAllowed = "copy";
  };

  const pilhas = columnsNormais.filter(c => c.title !== "Recebidos");

  const contarPorPrioridade = (key) =>
    columnsNormais.reduce((acc, col) =>
      acc + col.notas.filter(n => n.prioridade === key).length, 0
    );

  const contarPorTag = (tagId) =>
    columnsNormais.reduce((acc, col) =>
      acc + col.notas.filter(n =>
        Array.isArray(n.tags) && n.tags.some(t => String(t.id) === String(tagId))
      ).length, 0
    );

  const handleDragStart = (e, prioridadeKey) => {
    e.dataTransfer.setData("prioridade", prioridadeKey);
    e.dataTransfer.effectAllowed = "copy";
  };

  const handleClickPrioridade = (key) => {
    onSetFiltroPrioridade?.(filtroPrioridade === key ? null : key);
  };

  const handleClickTag = (tagId) => {
    onSetFiltroTag?.(String(filtroTag) === String(tagId) ? null : tagId);
  };

  const handleSelectPilha = (pilhaId) => {
    onSelectPilha?.(pilhaSelecionada === pilhaId ? null : pilhaId);
  };

  // Kanban está ativo quando não está em nenhum modo especial
  const modoKanban = !modoHome && !modoArquivadas && !modoGraficos && !modoProjetos;

  return (
    <aside className="cards-sidebar">

      {/* ── Logo centralizado ── */}
      <div className="csb__logo" onClick={() => navigate("/")}>
        <img src={images.ob2} alt="OnBox" className="csb__logo-img" />
      </div>

      {/* ── Botão voltar ── */}
      <div className="csb__back-wrap">
        <button
          className="csb__back-btn"
          onClick={() => navigate(donoContainerId ? `/containers/${donoContainerId}` : "/containers")}
          title="Voltar ao container"
        >
          <FontAwesomeIcon icon={faCircleLeft} />
          <span>Voltar</span>
        </button>
      </div>

      <div className="csb__divider" />

      {/* ── Navegação ── */}
      <nav className="csb__nav">

        {/* Home → EntityDetails embutido */}
        <button
          className={`csb__nav-item${modoHome ? " csb__nav-item--active" : ""}`}
          onClick={onToggleHome}
          title="Visão geral do projeto"
        >
          <FontAwesomeIcon icon={faHouse} size={14} />
          <span>Home</span>
        </button>

        {/* Pilhas → Kanban */}
        <button
          className={`csb__nav-item${modoKanban ? " csb__nav-item--active" : ""}`}
          onClick={onResetView}
          title="Ver pilhas (Kanban)"
        >
          <FontAwesomeIcon icon={faTableColumns} size={14} />
          <span>Pilhas</span>
        </button>

        <button
          className={`csb__nav-item ${modoArquivadas ? "csb__nav-item--active" : ""}`}
          onClick={onToggleArquivadas}
        >
          <FaFolderOpen size={14} />
          <span>Arquivos</span>
        </button>

        {/* ── Dashboard: oculto em setores ── */}
        {!ehSetor && (
          <button
            className={`csb__nav-item ${modoGraficos ? "csb__nav-item--active" : ""}`}
            onClick={onToggleGraficos}
          >
            <FontAwesomeIcon icon={faArrowTrendUp} size={14} />
            <span>Dashboard</span>
            <span className="csb__wip-badge">NOVO!!!</span>
          </button>
        )}

        <button
          className={`csb__nav-item ${modoProjetos ? "csb__nav-item--active" : ""}`}
          onClick={onToggleProjetos}
        >
          <FontAwesomeIcon icon={faDiagramProject} size={14} />
          <span>Projetos</span>
        </button>
      </nav>

      <div className="csb__divider" />

      {/* ── Prioridades draggable ── */}
      <div className="csb__section">
        <span className="csb__section-label">Prioridades</span>
        <p className="csb__priority-hint">Arraste para uma nota</p>
        <div className="csb__priority-list">
          {PRIORIDADES.map(({ key, label, color }) => {
            const count = contarPorPrioridade(key);
            const ativo = filtroPrioridade === key;
            return (
              <div
                key={key}
                className={`csb__priority-item${ativo ? " csb__priority-item--ativo" : ""}`}
                style={{ "--p-color": color }}
                draggable
                onDragStart={e => handleDragStart(e, key)}
                onClick={() => handleClickPrioridade(key)}
                title={ativo ? "Clique para remover filtro" : "Arraste para uma nota ou clique para filtrar"}
              >
                <FaFlag size={11} style={{ color }} />
                <span className="csb__priority-label">{label}</span>
                {count > 0 && (
                  <span className="csb__priority-count">{count}</span>
                )}
              </div>
            );
          })}
        </div>

        {filtroPrioridade && (
          <button
            className="csb__filter-clear"
            onClick={() => onSetFiltroPrioridade?.(null)}
          >
            ✕ Limpar filtro
          </button>
        )}
      </div>

      <div className="csb__divider" />

      {/* ── Tags ── */}
      <div className="csb__section">
        <div className="csb__section-header">
          <span className="csb__section-label">Tags</span>
          <button type="button" className="csb__tag-add" onClick={abrirNovaTag} title="Nova tag">+</button>
        </div>
        <p className="csb__priority-hint">Arraste para uma nota</p>

        {formTag && (
          <div className="csb__tag-form">
            <input
              className="csb__tag-input"
              value={formTag.nome}
              placeholder="Nome ou frase"
              maxLength={60}
              autoFocus
              onChange={e => setFormTag(p => ({ ...p, nome: e.target.value }))}
              onKeyDown={e => {
                if (e.key === "Enter") salvarTag();
                if (e.key === "Escape") fecharFormTag();
              }}
            />
            <div className="csb__tag-swatches">
              {CORES_TAG.map(c => (
                <button
                  key={c}
                  type="button"
                  className={`csb__tag-swatch${formTag.cor === c ? " csb__tag-swatch--on" : ""}`}
                  style={{ background: c }}
                  onClick={() => setFormTag(p => ({ ...p, cor: c }))}
                />
              ))}
              <input
                type="color"
                className="csb__tag-color"
                value={formTag.cor}
                onChange={e => setFormTag(p => ({ ...p, cor: e.target.value }))}
              />
            </div>
            <div className="csb__tag-fmt">
              <button
                type="button"
                className={`csb__tag-fmt-btn${formTag.negrito ? " csb__tag-fmt-btn--on" : ""}`}
                style={{ fontWeight: 700 }}
                onClick={() => setFormTag(p => ({ ...p, negrito: !p.negrito }))}
              >B</button>
              <button
                type="button"
                className={`csb__tag-fmt-btn${formTag.italico ? " csb__tag-fmt-btn--on" : ""}`}
                style={{ fontStyle: "italic" }}
                onClick={() => setFormTag(p => ({ ...p, italico: !p.italico }))}
              >I</button>
              <span
                className="csb__tag-chip csb__tag-chip--preview"
                style={{
                  "--tag-color": formTag.cor,
                  fontWeight: formTag.negrito ? 700 : 500,
                  fontStyle: formTag.italico ? "italic" : "normal",
                }}
              >
                {formTag.nome.trim() || "Prévia"}
              </span>
            </div>
            <div className="csb__tag-actions">
              <button type="button" className="csb__tag-btn csb__tag-btn--ok" onClick={salvarTag} disabled={!formTag.nome.trim()}>
                {editandoTagId ? "Salvar" : "Criar"}
              </button>
              <button type="button" className="csb__tag-btn" onClick={fecharFormTag}>Cancelar</button>
            </div>
          </div>
        )}

        <div className="csb__tag-list">
          {tags.length === 0 && !formTag && <span className="csb__empty">Nenhuma tag</span>}
          {tags.map(t => {
            const ativo = String(filtroTag) === String(t.id);
            const count = contarPorTag(t.id);
            return (
              <div
                key={t.id}
                className={`csb__tag-item${ativo ? " csb__tag-item--ativo" : ""}`}
                draggable
                onDragStart={e => handleDragStartTag(e, t.id)}
                onClick={() => handleClickTag(t.id)}
                title={ativo ? "Clique para remover filtro" : "Arraste para uma nota ou clique para filtrar"}
              >
                <span
                  className="csb__tag-chip"
                  style={{
                    "--tag-color": t.cor,
                    fontWeight: t.negrito ? 700 : 500,
                    fontStyle: t.italico ? "italic" : "normal",
                  }}
                >
                  {t.nome}
                </span>
                {count > 0 && <span className="csb__priority-count">{count}</span>}
                <span className="csb__tag-tools" onClick={e => e.stopPropagation()}>
                  <button type="button" onClick={() => abrirEditarTag(t)} title="Editar">✎</button>
                  <button type="button" onClick={() => onDeleteTag?.(t.id)} title="Excluir">✕</button>
                </span>
              </div>
            );
          })}
        </div>

        {filtroTag && (
          <button className="csb__filter-clear" onClick={() => onSetFiltroTag?.(null)}>
            ✕ Limpar filtro
          </button>
        )}
      </div>

      <div className="csb__divider" />

      {/* ── Pilhas ── */}
      <div className="csb__section csb__section--grow">
        <div className="csb__section-header">
          <span className="csb__section-label">Pilhas</span>
          {pilhaSelecionada && (
            <button
              className="csb__pilha-clear"
              onClick={() => onSelectPilha?.(null)}
              title="Mostrar todas as pilhas"
            >
              ✕
            </button>
          )}
        </div>
        <div className="csb__pilhas-list">
          {pilhas.length === 0 && <span className="csb__empty">Nenhuma pilha</span>}
          {pilhas.map(col => {
            const isSelected = pilhaSelecionada === col.id;
            return (
              <div
                key={col.id}
                className={`csb__pilha-item${isSelected ? " csb__pilha-item--selected" : ""}`}
                onClick={() => handleSelectPilha(col.id)}
                title={isSelected ? "Clique para mostrar todas" : "Clique para isolar esta pilha"}
              >
                <span
                  className="csb__pilha-dot"
                  style={{ background: col.cor_fundo && col.cor_fundo !== "transparent" ? col.cor_fundo : "#94a3b8" }}
                />
                <span className="csb__pilha-name">{col.title}</span>
                <span className="csb__pilha-count">{col.notas?.length ?? 0}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Membros ── */}
      {membros.length > 0 && (
        <>
          <div className="csb__divider" />
          <div className="csb__members">
            {membros.slice(0, 6).map(m => (
              <img
                key={m.id}
                src={m.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(m.nickname || "M")}&background=81C784&color=fff`}
                alt={m.nickname || "Membro"}
                className="csb__member-avatar"
                title={m.nickname}
              />
            ))}
          </div>
        </>
      )}
    </aside>
  );
}